import { render, staticRenderFns } from "./ModalTopup.vue?vue&type=template&id=af9176a0&"
import script from "./ModalTopup.vue?vue&type=script&lang=js&"
export * from "./ModalTopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports